import $api from "../http";
import { ICountry } from "../models/Country";

class CountriesServiceClass {
  async getAllCountries() {
    return await $api.get<ICountry[]>("api/country");
  }
}

export const CountriesService = new CountriesServiceClass();
